import React, { useEffect, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Button } from 'react-bootstrap'
import { reduxForm } from 'redux-form';
import { Prompt } from 'react-router'
import PropTypes from 'prop-types';
import { updateAssessment, getSiteById } from 'middleware/assessments'
import PageList from 'components/edit-site/pages/List'
import ColourPalette from 'components/edit-site/ColourPalette';
import ActiveCampaign from 'components/edit-site/ActiveCampaign'
//import Niche from 'components/edit-site/Niche'
import UploadLogo from 'components/edit-site/UploadLogo'
// import HeaderCover from 'components/edit-site/HeaderCover'
import MenuLinks from 'components/edit-site/menu-links'
import ButtonLoader from 'components/core/loader/button-loader'
import { getSite , diffObjects } from 'utils/helpers'
import _ from 'lodash';
import { MenuBar } from 'utils/svg'
import { getCurrentUser } from 'middleware/auth'
import { change as reduxChange } from 'redux-form'
// import searchIcon from '../../images/search.png';
// import filterIcon from '../../images/filter.png';
import ConfirmAlert from 'components/core/confirm-alert'
import { confirmAlert } from 'react-confirm-alert';
import { AllColors } from 'constants/theme'
import { isDisabledSite, mixpanelCommonData, isTravelTemplate  } from 'utils/helpers';
import { MixpanelContext } from 'utils/tracking';
//import { getSite } from 'utils/helpers';
import Skeleton from 'react-loading-skeleton';
import blogBanner from 'images/blog-banner.png';
import travelBanner from 'images/wizrd-plan-header.jpeg';
import defaultFavIcon from 'images/default-favicon.svg';
import HomeTheme from 'components/edit-site/theme/homeTheme';
const EditSitePage =(props) => {
    const dispatch = useDispatch();
    const { handleSubmit , initialize } = props
    const [ open, setOpen ] = useState(false)
    const [ isValid, setIsValid ] = useState(true)
    const [ modalType, setModalType ] = useState(null)
    const { assessmentData ,updateAssessmentLoader, siteBuildLoading } = useSelector((state) => state.assessment)
    const form  = useSelector((state) => state.form.assessmentUpdateForm)
    const unsplashImages  = useSelector((state) => state.assessment.unsplashImages)
    const [ menuLinks, setMenuLinks ] = useState(form?.values?.menuLinks || [])
    const data = useSelector(state => state.user.sessionData?.data?.data)
    const site =   useSelector((state) => state.assessment.site)
    const [ footerLinks, setFooterLinks ] = useState(form?.values?.footerLinks || [])

    const [ colorPalette , setColorPalette ] = useState(AllColors())

    const loading =  useSelector((state) => state.assessment.loading)
    const [ customOpen, setCustomPopup ] = useState(false)
    const mixpanel = useContext(MixpanelContext);
    const isDisabled = isDisabledSite(data?.user?.status);
    const siteLocalData = JSON.parse(localStorage.site)

    const validUrls = () => {
        let result = false
        const names= menuLinks.map((item)=> item.name.toLowerCase())
        const isDuplicateName =  !_.isEmpty(names.filter((item, index) => names.indexOf(item) != index))
        const urls= menuLinks.map((item)=> item.url)
        const isDuplicateUrl =  !_.isEmpty(urls.filter((item, index) => urls.indexOf(item) != index))
        if(isDuplicateName || isDuplicateUrl){
            result =  false
        }else{
            result =  true
        }
        setIsValid({ type: 'Header Menu or submenu',result: result })
        const obj = setTimeout(()=> {
            setIsValid(true)
            clearTimeout(obj)
        },3000)
        return result
    }

    const isValidMenu = () => {
        const dd = menuLinks && menuLinks.map((item) => {
            return item.subMenuLinks && item.subMenuLinks.map((sub) => sub.name).includes('')
        })
        const result =  menuLinks && !menuLinks.map((item) => item.name ).includes(undefined) &&!dd.includes(true)
        setIsValid({ type: 'Header Menu or submenu',result: result })
        const obj = setTimeout(()=> {
            setIsValid(true)
            clearTimeout(obj)
        },3000)
        return result

    }
    const isValidFooterMenu = () => {
        const result =  _.isEmpty(footerLinks) ? true : !footerLinks.map((item) => item?.name ).includes(undefined)
        setIsValid({ type: 'Footer Menu',result: result })
        const obj = setTimeout(()=> {
            setIsValid(true)
            clearTimeout(obj)
        },3000)
        return result

    }
    const handleClose = () => {
        setModalType(null)
        setCustomPopup(false)
        setOpen(false)
    }

    const handleCloseModal = () => {
        const siteColors = site?.colors && JSON.parse(site.colors)
        const colors = form?.values?.colors || site?.colors
        if(modalType == 'header'){
            const colorObj = Object.assign({},JSON.parse(colors))
            colorObj[ 'header-background' ] = siteColors[ 'header-background' ]
            dispatch(reduxChange('assessmentUpdateForm', 'colors', JSON.stringify(colorObj)))
            dispatch(reduxChange('assessmentUpdateForm', 'header', site?.header))
            dispatch(reduxChange('assessmentUpdateForm', 'coverImage', site?.coverImage))
        }else if(modalType == 'menuLinks'){
            setFooterLinks(form.values.footerLinks)
            setMenuLinks([ ...form.values.menuLinks ])
        }else if(modalType === 'colors'){
            const colorObj = Object.assign({},JSON.parse(colors))
            colorObj[ 'header-background' ] = colors && JSON.parse(colors)[ 'header-background' ]
            dispatch(reduxChange('assessmentUpdateForm', 'colors', JSON.stringify(colorObj)))
        }
        else{
            dispatch(reduxChange('assessmentUpdateForm', modalType, site && site[ modalType ] ))
        }

        handleClose()
    }

    const handleEvent = (isSuccess) => {
        let eventName = isSuccess ? 'Updated' : 'Failed Updation';
        switch(modalType){
        case 'colour':
            eventName = `${ eventName } Site Color`;
            break;
        case 'logo':
            eventName = `${ eventName } Site Logo`;
            break;
        case 'menulinks':
            eventName = `${ eventName } Site Menu Link`;
            break;
        case 'favicon':
            eventName = `${ eventName } Site Favicon Icon`;
            break;
        case 'header':
            eventName = `${ eventName } Site Header`;
            break;
        }
        //dispatch(siteBuild(site.id,() => {}))
        mixpanel.track(eventName, mixpanelCommonData({ siteId: site?.id, status: site?.status, domain: site?.domain, 'user identifier': data?.user?.id }));
    }
    const saveData = (formData) => {
        formData[ 'menuLinks' ] = menuLinks
        formData[ 'footerLinks' ] = footerLinks
        dispatch(updateAssessment(site?.id, formData, site?.domain, handleClose, handleEvent))
    }

    const handleBlockedNavigation = (event) => {
        const pathname = event?.pathname
        const obj = diffObjects(form?.values,site)
        if(!_.isEmpty(obj)){
            confirmAlert({
                // eslint-disable-next-line react/display-name
                customUI: ({ onClose }) => {

                    const handleNavigation = () => {
                        onClose()
                        handleClose && handleClose()
                        window.location.href = pathname

                    }
                    const handleModalClose = () => {
                        onClose()
                    }
                    const handleSave = () => {
                        onClose()
                        saveData(form?.values)
                    }
                    return(
                        <ConfirmAlert
                            btnTitle='save'
                            key={ 'box' }
                            handleNavigation={ handleNavigation }
                            linkLabel={ 'leave' }
                            onClose={ handleModalClose }
                            handleAction={ () =>  handleSave() }
                            subHeading='If you leave before saving, your changes will be lost.' />
                    );
                }
            });
            return false

        }
        return true
    }

    useEffect(() => {
        dispatch({
            type: 'SET_ACTIVE_SIDEBAR',
            payload: '/edit-site'
        })
        dispatch(getSiteById(getSite()?.id))
        //dispatch(getAssessment())
        dispatch(getCurrentUser());

        return () => {
        }
    }, [  ]);

    useEffect(() => {
        if(!_.isEmpty(form?.values?.menuLinks)){
            setMenuLinks(form?.values?.menuLinks)
        }

    }, [ form?.values?.menuLinks ])

    useEffect(() => {
        if(form?.values?.footerLinks){
            setFooterLinks(form?.values?.footerLinks)
        }

    }, [ form?.values?.footerLinks ])

    useEffect(() => {
        if(!_.isEmpty(form?.values?.colors && JSON.parse(form?.values?.colors)?.name === 'custom-color')){
            const obj = { label: 'Custom Color', value: JSON.parse(form?.values?.colors),imageUrl: undefined }
            colorPalette.pop()
            colorPalette.push(obj)
            setColorPalette(colorPalette)
        }
    }, [ form?.values?.colors ])

    useEffect(() => {
        mixpanel.track(`Click on ${ modalType } (EDIT SITE )`,mixpanelCommonData({}))
    },[ modalType ])

    useEffect(() => {
        if(!_.isEmpty(site)){
            const siteMenuLinks = site && site.menuLinks ? [ ...site.menuLinks ] : [];
            const siteFooterLinks = site && site.footerLinks ? [ ...site.footerLinks ] : [];
            const formData = {
                activeCampaign: site.activeCampaign,
                colors: site.colors,
                logoUrl: site.logoUrl,
                coverImage: site.coverImage,
                faviconUrl: site.faviconUrl,
                header: site.header,
                footerText:  site.footerText,
                footerLinks: _.isEmpty(siteFooterLinks ) ? [] : siteFooterLinks,
                menuLinks: _.isEmpty(siteMenuLinks ) ? [ { name: 'home',url: '' }, { name: 'contact',url: 'contact' } ] : siteMenuLinks,
                imageAltTextLogo: site?.imageAltTextLogo || '',
                imageAltText: site?.imageAltText || '',
                templateName: site?.templateName ?? 'CLASSIC',
                backgroundType: site?.backgroundType ?? 'IMAGE',
                headerOverlay: site?.headerOverlay ?? false,
                topMenuTransparent: site?.topMenuTransparent ?? true,
                makeTransparent: site?.makeTransparent ?? true,
                optIn: site?.optIn ?? true,
                isSearch: site?.isSearch ?? false,
                subscriptionButton: site?.subscriptionButton ?? false
            }
            initialize(formData)
        }

    }, [ site ])
    const handleModal = (event, type) => {
        event.preventDefault()
        if (!isDisabled) {
            setModalType(!open ? type : null)
            setOpen(!open)
        }
    }
    const getBase64 = (base64, fieldName) => {
        dispatch(reduxChange('assessmentUpdateForm', fieldName, base64))
    }

    const clearImage = (event, field) => {
        event.preventDefault()
        dispatch(reduxChange('assessmentUpdateForm', field, ''))
        dispatch(reduxChange('assessmentUpdateForm', 'imageAltTextLogo', ''))
    }

    const renderModalView = () =>{
        switch(modalType){
        // case 'niche':
        //     return <Niche form={ form } handleSubmit={ handleSubmit }  submitData= { submitData } assessmentData={ assessmentData } loading={ updateAssessmentLoader } />
        case 'colors':
            return <ColourPalette formName={ 'assessmentUpdateForm' } handleClose={ handleClose } customOpen={ customOpen } setCustomPopup={ setCustomPopup }  previewFile={ form?.values?.coverImage }  handleSubmit={ handleSubmit }   formValues={ form?.values }  site={ site }  setColorPalette={ setColorPalette } colorPalette={ colorPalette }  onClose={ handleClose }  loading={ updateAssessmentLoader } />
        case 'logoUrl':
            return <UploadLogo handleSubmit={ handleSubmit }  handleClose={ handleClose } fieldName='logoUrl' previewFile={ form?.values?.logoUrl } unsplashImages={ unsplashImages } clearImage={ clearImage } getBase64={ getBase64 }  assessmentData={ assessmentData } loading={ updateAssessmentLoader } isAlt = { true } fieldAltName = 'imageAltTextLogo'/>
        case 'menuLinks':
            return <MenuLinks isValidFooterMenu={ isValidFooterMenu }  footerLinks={ footerLinks } setFooterLinks={ setFooterLinks }  validUrls={ validUrls } isValidMenu={ isValidMenu } handleClose={ handleClose } menuLinks={ menuLinks } setMenuLinks={ setMenuLinks }   isValid={ isValid } loading={ updateAssessmentLoader } />
        case 'faviconUrl':
            return <UploadLogo site={ site } form={ form } allowExtenstions={ 'image/jpeg, image/png, .ico' } handleSubmit={ handleSubmit }   fieldName='faviconUrl' previewFile={ form?.values?.faviconUrl } unsplashImages={ unsplashImages } clearImage={ clearImage } getBase64={ getBase64 }  assessmentData={ assessmentData } handleClose={ handleClose } loading={ updateAssessmentLoader } />
        case 'header':
            return <HomeTheme allowExtenstions={ 'image/jpeg, image/png, .ico' } formName={ 'assessmentUpdateForm' } customOpen={ customOpen } setCustomPopup={ setCustomPopup }  previewFile={ form?.values?.coverImage }  handleSubmit={ handleSubmit }   formValues={ form?.values } assessmentData={ assessmentData }  setColorPalette={ setColorPalette } colorPalette={ colorPalette }  onClose={ handleClose }  loading={ updateAssessmentLoader }  />
        case 'activeCampaign':
            return <ActiveCampaign reduxFormValues={ form?.values } onClose={ handleClose } site={ site } />
        }
    }
    const getHeaderCover = () => {
        const values  = form?.values
        let cover =  values?.coverImage ? <img src={ values?.coverImage } alt="s"/> : (values?.colors && JSON.parse(values?.colors)[ 'header-background' ] && <span style={ { background: JSON.parse(values?.colors)[ 'header-background' ] } } ></span>)
        cover = cover || (site?.coverImage ?  <img src={ site?.coverImage } alt="d"/> : (site?.colors && JSON.parse(site?.colors)[ 'header-background' ] &&  <span style={ { background: JSON.parse(site?.colors)[ 'header-background' ] } }></span>))
        return cover || (isTravelTemplate() ? <img src={ travelBanner } alt='cover' /> : <img src={ blogBanner } alt="cover"/>)
    }
    const obj =  _.isEmpty(diffObjects(form?.values,site)) ? diffObjects(form?.values?.menuLinks,siteLocalData?.menuLinks) : diffObjects(form?.values,site)
    return(
        <main className="dashboard-data dashboard-edit-site-wrap">
            <Prompt
                when={ true }
                message={ handleBlockedNavigation }/>
            <section className="dashboard-body">
                <div className="dashboard-header">
                    <div className="dashboard-title edit-site-title">
                        <h1>Edit Site</h1>
                    </div>
                </div>
                <div className='edit-site-panel'>
                    <div className="edit-site-btns">
                        {/*<Form.Group controlId="formBasicEmail">
                            <Form.Label>Blog / Niche:</Form.Label>
                            <div className={ `edit-site-btn ${ isDisabled ? 'disabled-link' : '' }` } onClick={ (event) => handleModal(event,'niche') }>
                                {loading && !site ? <Skeleton className="content-col-12" count={ 1 } width={ '100%' } /> : <><img src={ niche?.icon } />{ niche?.label }</> }
                            </div>
                        </Form.Group>*/}
                        <Form.Group controlId="formBasicEmail" className="edit-header-footer">
                            <Form.Label>Theme Builder </Form.Label>
                            <div onClick={ (event) => handleModal(event,'header') } className="image-box">
                                { getHeaderCover() }
                            </div>
                        </Form.Group>
                        {/* <Form.Group controlId="formBasicEmail">
                            <Form.Label>Color palette:</Form.Label>
                            <div className={ `edit-site-btn ${ isDisabled ? 'disabled-link' : '' }` } onClick={ (event) => handleModal(event,'colors') }>
                                {loading && !site  ? <Skeleton className="content-col-12" count={ 1 } width={ '100%' } /> : <><span className="checkbox-colors round-border">
                                    <span style={ { backgroundColor: form?.values?.colors && JSON.parse(form?.values?.colors)[ 'top-menu' ] } }></span>
                                </span>{form?.values?.colors && JSON.parse(form?.values?.colors)?.name }</>}
                            </div>
                        </Form.Group> */}
                        <Form.Group controlId="formBasicEmail" className='menu-links'>
                            <Form.Label>Menu/Footer</Form.Label>
                            <div className={ `edit-site-btn no-arrow ${  isDisabled ? 'disabled-link' : '' }` } onClick={ (event) =>  handleModal(event,'menuLinks') }>
                                {loading && !site ? <Skeleton className="content-col-12" count={ 1 } width={ '100%' } /> : <MenuBar/> }
                            </div>
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail" className='logo'>
                            <Form.Label>Site logo</Form.Label>
                            <div className={ `logo-preview-btn edit-site-btn no-arrow ${  isDisabled ? 'disabled-link' : '' }` } onClick={ (event) =>  handleModal(event,'logoUrl') }>
                                {loading && !site ? <Skeleton count={ 1 } className="content-col-12" width={ '100%' } /> : (form?.values?.logoUrl  ? <img src={ form?.values?.logoUrl || site?.logoUrl } width={ 20 } /> : site?.websiteName ) }
                            </div>
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail" className='favicon'>
                            <Form.Label>Site icon</Form.Label>
                            <div className={ `logo-preview-btn edit-site-btn no-arrow ${  isDisabled ? 'disabled-link' : '' }` } onClick={ (event) => handleModal(event,'faviconUrl') }>
                                { loading && !site ? <Skeleton count={ 1 } width={ '100%' } /> : <img src={ form?.values?.faviconUrl || site?.faviconUrl || defaultFavIcon } width={ 20 } /> }
                            </div>
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail" className='action-btn'>
                            <Form.Label>Action Button</Form.Label>
                            <div className={ `logo-preview-btn edit-site-btn no-arrow ${  isDisabled ? 'disabled-link' : '' }` } >
                                { loading && !site ? <Skeleton count={ 1 } width={ '100%' } /> : <span title={ site?.activeCampaign?.buttonText || 'Subscribe' } onClick={ (event) => handleModal(event,'activeCampaign') } className='action-text' >
                                    {site?.activeCampaign?.buttonText || 'Subscribe' }
                                </span> }
                            </div>
                        </Form.Group>

                        <Form.Group className='update-site'>
                            <Form.Label></Form.Label>
                            { (!_.isEmpty(obj) || site?.footerText !== form?.values?.footerText) ? <ButtonLoader
                                loadingText={ 'Saving..' }
                                button={ <Button onClick={ () => saveData( form?.values ) } variant="primary" >Save Changes</Button> }
                                loading={ updateAssessmentLoader || siteBuildLoading }
                            /> : <Button variant="primary" disabled={ true }>Save Changes</Button> }
                        </Form.Group>
                    </div>
                    <Modal show={ open } onHide={ handleCloseModal } className={ `${ customOpen || modalType === 'header' ? 'new-modal custom-color-modal header-edit-modal' : 'new-modal logo-upload-modal' }` }>
                        {renderModalView()}
                    </Modal>
                </div>
                <div className="dashboard-header site-filter-header">
                    <div className="dashboard-title">
                        {/* <h3>Pages</h3> */}
                    </div>
                    <PageList />
                </div>
            </section>
        </main>

    )
}
EditSitePage.propTypes = {
    handleSubmit: PropTypes.func,
    initialize: PropTypes.object,
    onClose: PropTypes.func
};

String.prototype.uppercase = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
};
export default reduxForm({
    form: 'assessmentUpdateForm',
    destroyOnUnmount: false
})(EditSitePage);